import React, { Component } from 'react'
import Drawer from '@material-ui/core/Drawer';
import { FiMenu } from "react-icons/fi";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Logo from '../Header/logo.svg'
import { AppContext } from '../../AppContext';


class Navigation extends Component {
    static contextType = AppContext;

    constructor(props){
        super(props);

        this.state = {
            open: false,
        }

        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout = () => {
        const { setUserLogged } = this.context;
        setUserLogged(false)
        localStorage.clear();
        window.location.reload();
        return false;
    }

    render(){
        const { isUserLogged } = this.context;

        return(
            <div id="Navigation">
                
                <a className="d-block d-lg-none menu-btn" onClick={() => this.setState({ open: true })}><FiMenu /></a>
                <Drawer open={this.state.open} onClose={() => this.setState({ open: false })}>
                <List>
                    <figure>
                        <a href="https://futebolcardsaude.com.br" onClick={(e) => this.setState({ open: false })}><img src={Logo} alt="FC Saúde" height="35" /></a>
                    </figure>
                    <a href="https://futebolcardsaude.com.br/#planos" onClick={(e) => this.setState({ open: false })}>
                        <ListItem button>
                                <ListItemText>Planos</ListItemText>
                        </ListItem>
                    </a>
                    <a href="https://futebolcardsaude.com.br/#beneficios" onClick={(e) => this.setState({ open: false })}>
                        <ListItem button>
                                <ListItemText>Benefícios</ListItemText>
                        </ListItem>
                    </a>
                    <a href="https://futebolcardsaude.com.br/#contato" onClick={(e) => this.setState({ open: false })}>
                        <ListItem button>
                                <ListItemText>Contato</ListItemText>
                        </ListItem>
                    </a>
                    <a href="https://futebolcardsaude.com.br/#planos" onClick={(e) => this.setState({ open: false })}>
                        <ListItem button>
                                <ListItemText>Assine agora</ListItemText>
                        </ListItem>
                    </a>
                    {isUserLogged === 'true' ? (
                        <a href="#" onClick={(e) => this.setState({ open: false })} onClick={() => this.handleLogout()}>
                            <ListItem button>
                                    <ListItemText>Sair</ListItemText>
                            </ListItem>
                        </a>
                    ) : (
                        <a href="https://futebolcardsaude.com.br/acesso" onClick={(e) => this.setState({ open: false })}>
                            <ListItem button>
                                    <ListItemText>Entrar</ListItemText>
                            </ListItem>
                        </a>
                    )}
                    
                </List>
                </Drawer>

            </div>
        )
    }

}

export default Navigation